// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__eoZzA","signatureBlock":"Footer_signatureBlock__1ZqXm","signature":"Footer_signature__3a0im"};